export default "__VITE_ASSET__d6ea7df4__"